import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createShoppingListProductSchemas } from 'shared/db/validation/schemas/shoppingListProduct';
import { Validator } from 'shared/db/validation/validator';
import { DeleteRawRecord, UpdateRawRecord } from 'shared/types/rawRecordFields';
import { ShoppingListProductRawRecord } from 'shared/types/ShoppingListProduct';
import { ShoppingListProductDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createShoppingListProductSchemas();

const addValidator = createDBEntityValidator<ShoppingListProductRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<
    UpdateRawRecord<ShoppingListProductRawRecord>
>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-shopping-list-products'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createShoppingListProductsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const shoppingListProductsInputValidation: ShoppingListProductDBValidation =
    {
        add: createShoppingListProductsInputValidation(
            addValidator,
            validationStrategy,
        ),
        update: createShoppingListProductsInputValidation(
            updateValidator,
            validationStrategy,
        ),
        delete: createShoppingListProductsInputValidation(
            deleteValidator,
            validationStrategy,
        ),
    };
